/**
 * Returns the minimum scale multiplier value (float)
 * to apply to a fabric image for it to cover the canvas
 * @param {Object} image a fabric image object
 * @param {Number} exifNumber exif orientation number
 * @param {Object} canvas the given fabric canvas instance
 * @returns a decimal-based multiplier value.
 */
export const getScaleFactor = (image, exifNumber, canvas, imageAngle) => {
  let scaleFactor
  let imgWidth = image.width
  let imgHeight = image.height
  let artboardWidth = canvas.width
  let artboardHeight = canvas.height

  if (exifNumber && (exifNumber === 6 || exifNumber === 8)) {
    imgWidth = image.height
    imgHeight = image.width

    image['exifCompensatedHeight'] = image.width
    image['exifCompensatedWidth'] = image.height
  }

  if (imageAngle && ((imageAngle / 90) % 2 !== 0)) {
    imgWidth = image.height
    imgHeight = image.width
  }

  if (imgWidth >= imgHeight) {
    scaleFactor = artboardHeight / imgHeight
    if ((scaleFactor * imgWidth) < artboardWidth) {
      scaleFactor = artboardWidth / imgWidth
    }
  } else if (imgWidth < imgHeight) {
    scaleFactor = artboardWidth / imgWidth
    if ((scaleFactor * imgHeight) < artboardHeight) {
      scaleFactor = artboardHeight / imgHeight
    }
  }

  return scaleFactor
}



// WEBPACK FOOTER //
// ./uncommon-client/utilities/imageSetting.js